import { useRouter } from 'next/router'
import React from 'react'
import { useToasts } from 'react-toast-notifications'

import Loading from 'lib/components/Loading'
import useUser, { UseUserData } from 'lib/hooks/useUser'

const AuthContext = React.createContext<[UseUserData, Function]>(null)

function AuthProvider(props) {
  const [user, loading, error, updateAuth] = useUser()
  const router = useRouter()
  const { addToast } = useToasts()

  if (loading) {
    return <Loading />
  }

  if (error) {
    return (
      <div style={{ color: 'red' }}>
        <p>Uh oh... There's a problem. Try refreshing the app.</p>
        <pre>{error.message}</pre>
      </div>
    )
  }

  if (user.auth && user.data) {
    return <AuthContext.Provider value={[user, updateAuth]} {...props} />
  }

  router.push('/')
  addToast('You were logged out', { appearance: 'info' })

  return null
}

function useAuth() {
  const context = React.useContext(AuthContext)
  if (context === undefined) {
    throw new Error(`useAuth must be used within a AuthProvider`)
  }
  return context
}

export { AuthProvider, useAuth }
